const sectionsToRender = [
  {
    id: '#cart-counter',
    section: 'cart-counter',
    selector: '#shopify-section-cart-counter'
  },
  {
    id: '#CartDrawer-Body',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #CartDrawer-Body'
  }
];

function getCartDrawer() {
  return document.querySelector('cart-drawer');
}

function blockCartNavigation(duration = 5000) {
  window.__cartRedirectBlock = true;
  clearTimeout(window.__cartRedirectBlockTimer);
  window.__cartRedirectBlockTimer = setTimeout(() => {
    window.__cartRedirectBlock = false;
  }, duration);
}

function isCartPageUrl(url) {
  try {
    return (
      new URL(url, window.location.origin).pathname.replace(/\/$/, '') ===
      '/cart'
    );
  } catch (error) {
    return false;
  }
}

function initCartNavigationBlock() {
  if (window.__cartNavBlockInit) return;
  window.__cartNavBlockInit = true;

  if ('navigation' in window && typeof window.navigation.addEventListener === 'function') {
    window.navigation.addEventListener('navigate', event => {
      if (!window.__cartRedirectBlock || !isCartPageUrl(event.destination.url)) {
        return;
      }

      event.preventDefault();
      getCartDrawer()?.open();
    });
  } else {
    try {
      const originalAssign = window.location.assign.bind(window.location);
      window.location.assign = function (url, ...args) {
        if (window.__cartRedirectBlock && isCartPageUrl(url)) return;
        return originalAssign(url, ...args);
      };

      const originalReplace = window.location.replace.bind(window.location);
      window.location.replace = function (url, ...args) {
        if (window.__cartRedirectBlock && isCartPageUrl(url)) return;
        return originalReplace(url, ...args);
      };
    } catch (error) {
      // Ignore browsers that disallow location patching.
    }
  }

  document.addEventListener(
    'click',
    event => {
      if (!window.__cartRedirectBlock) return;

      const link = event.target.closest('a[href]');
      if (!link || !isCartPageUrl(link.href)) return;

      if (link.closest('cart-drawer')) return;

      event.preventDefault();
      event.stopPropagation();
      getCartDrawer()?.open();
    },
    true
  );
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      event => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.querySelector('#CartDrawer-Overlay').addEventListener(
      'click',
      this.close.bind(this)
    );
    this.setCartLink();
    this.parentElement.addEventListener(
      'shopify:section:select',
      () => this.open()
    );
    this.parentElement.addEventListener(
      'shopify:section:deselect',
      () => this.close()
    );
  }

  setCartLink() {
    const cartLink = document.querySelector('[data-cart-link]');
    cartLink?.setAttribute('role', 'button');
    cartLink?.setAttribute('aria-haspopup', 'dialog');
    cartLink?.addEventListener('click', event => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink?.addEventListener('keydown', event => {
      if (event.code.toUpperCase() !== 'SPACE') return;
      event.preventDefault();
      this.open(cartLink);
    });
  }

  open(opener) {
    if (opener) this.setActiveElement(opener);
    this.classList.add('is-visible');
    this.querySelector('.cart-drawer__inner').setAttribute('aria-hidden', 'false');

    this.addEventListener('transitionend', () => {
      this.focusOnCartDrawer();
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    blockCartNavigation();
  }

  close() {
    this.classList.remove('is-visible');
    removeTrapFocus(this.activeElement);

    const isHeaderMenuOpen = header.classList.contains('menu-open');

    if (isHeaderMenuOpen) {
      return;
    }

    document.body.classList.remove('overflow-hidden');

    if (window.location.pathname === '/cart') {
      const cartDrawerForm = document.getElementById('CartDrawer-FormSummary');
      if (cartDrawerForm) {
        cartDrawerForm.submit();
      }
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  renderContents(response, open = true) {
    this.getSectionsToRender()?.forEach(section => {
      try {
        const sectionElement = document.querySelector(section.id);
        const sectionHtml = response.sections?.[section.section];

        if (!sectionElement || !sectionHtml) return;

        const innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
        if (innerHTML != null) {
          sectionElement.innerHTML = innerHTML;
        }
      } catch (error) {
        console.error(`Cart drawer section render failed: ${section.section}`, error);
      }
    });

    if (open) {
      this.open();
    }
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    const element = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);

    return element?.innerHTML ?? null;
  }

  focusOnCartDrawer() {
    const cartDrawer = this.querySelector('.cart-drawer');
    if (cartDrawer) {
      cartDrawer.focus();
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return sectionsToRender;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

async function refreshCartDrawer(open = true) {
  const cartDrawer = getCartDrawer();
  if (!cartDrawer) return;

  const sectionIds = cartDrawer
    .getSectionsToRender()
    .map(section => section.section)
    .join(',');

  try {
    const response = await fetch(
      `${window.location.pathname}?sections=${sectionIds}`
    );
    const sections = await response.json();
    cartDrawer.renderContents({ sections }, open);
  } catch (error) {
    console.error('Error refreshing cart drawer:', error);
  }
}

function showProductFormError(form, message) {
  const errorWrapper = form.closest('product-form')?.querySelector('[data-error-wrapper]');
  if (!errorWrapper) {
    console.error(message);
    return;
  }

  errorWrapper.classList.toggle('hidden', !message);
  errorWrapper.textContent = message || '';
}

function validateProductForm(form) {
  const productForm = form.closest('product-form');
  if (!productForm) return true;

  const purchaseOptions = document.querySelector('purchase-options');
  if (
    purchaseOptions &&
    !purchaseOptions.isOneTimePurchase() &&
    !productForm.hasAttribute('data-has-selling-plan')
  ) {
    purchaseOptions.showError();
    return false;
  }

  return true;
}

function addToCart(form) {
  blockCartNavigation(5000);

  const cartDrawer = getCartDrawer();
  const submitButton = form.querySelector('[name="add"], button[type="submit"]');
  submitButton?.classList.add('disabled');

  const formData = new FormData(form);
  const productForm = form.closest('product-form');

  if (productForm?.hasAttribute('data-has-pre-order')) {
    formData.append('properties[Pre-order]', '✓');
  }

  if (cartDrawer) {
    formData.append(
      'sections',
      cartDrawer.getSectionsToRender().map(section => section.section).join(',')
    );
    formData.append('sections_url', window.location.pathname);
  }

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  config.body = formData;

  return fetch(`${routes.cart_add_url}`, config)
    .then(response => response.json())
    .then(response => {
      if (response.status) {
        throw new Error(
          typeof response.description === 'string'
            ? response.description
            : 'Unable to add item to cart.'
        );
      }

      showProductFormError(form, false);

      if (cartDrawer && response.sections) {
        cartDrawer.renderContents(response);
      } else {
        refreshCartDrawer(true);
      }

      return response;
    })
    .finally(() => {
      submitButton?.classList.remove('disabled');
    });
}

function bindCartAddForms() {
  document.addEventListener(
    'submit',
    event => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const action = form.getAttribute('action') || '';
      if (!action.includes('/cart/add')) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (!validateProductForm(form)) return;

      addToCart(form).catch(error => {
        showProductFormError(form, error.message);
      });
    },
    true
  );
}

function interceptCartAddRequests() {
  if (window.__cartAddRequestPatched) return;
  window.__cartAddRequestPatched = true;

  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    const isCartAdd = url.includes('/cart/add');

    if (isCartAdd) {
      blockCartNavigation(5000);
    }

    const response = await originalFetch.apply(this, args);

    if (!isCartAdd || !response.ok) return response;

    try {
      const hadSectionsRequest =
        args[1]?.body instanceof FormData && args[1].body.has('sections');
      const data = await response.clone().json();

      if (data.status) return response;

      if (!hadSectionsRequest) {
        const cartDrawer = getCartDrawer();
        if (cartDrawer && !cartDrawer.classList.contains('is-visible')) {
          await refreshCartDrawer(true);
        }
      }
    } catch (error) {
      // Ignore non-JSON cart add responses.
    }

    return response;
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__isCartAddRequest = typeof url === 'string' && url.includes('/cart/add');
    return originalOpen.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function (...args) {
    if (this.__isCartAddRequest) {
      blockCartNavigation(5000);
      this.addEventListener('load', () => {
        if (this.status < 200 || this.status >= 300) return;

        const cartDrawer = getCartDrawer();
        if (cartDrawer && !cartDrawer.classList.contains('is-visible')) {
          refreshCartDrawer(true);
        }
      });
    }

    return originalSend.apply(this, args);
  };
}

window.refreshCartDrawer = refreshCartDrawer;
window.blockCartPageRedirect = blockCartNavigation;

initCartNavigationBlock();
bindCartAddForms();
interceptCartAddRequests();
